export function Field({ label, hint, required, children, testid }) {
  return (
    <div className="space-y-2" data-testid={testid}>
      <label className="label-eyebrow block">
        {label}
        {required ? <span className="text-[#A67C2E] ml-1">*</span> : null}
      </label>
      {children}
      {hint ? <p className="text-xs text-[#8B8378]">{hint}</p> : null}
    </div>
  );
}

export function TextInput({ value, onChange, placeholder, type = "text", testid }) {
  return (
    <input
      type={type}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="field-input"
      data-testid={testid}
    />
  );
}

export function NumberInput({ value, onChange, placeholder, testid, step, min }) {
  return (
    <input
      type="number"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="field-input"
      step={step}
      min={min}
      data-testid={testid}
    />
  );
}

export function TextArea({ value, onChange, placeholder, testid, rows = 4 }) {
  return (
    <textarea
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      className="field-input"
      data-testid={testid}
    />
  );
}

export function YesNoToggle({ value, onChange, testid }) {
  return (
    <div className="flex gap-3" role="radiogroup" data-testid={testid}>
      <button
        type="button"
        onClick={() => onChange(true)}
        className={`radio-pill ${value === true ? "active" : ""}`}
        data-testid={`${testid}-yes`}
        aria-checked={value === true}
        role="radio"
      >
        Yes
      </button>
      <button
        type="button"
        onClick={() => onChange(false)}
        className={`radio-pill ${value === false ? "active" : ""}`}
        data-testid={`${testid}-no`}
        aria-checked={value === false}
        role="radio"
      >
        No
      </button>
    </div>
  );
}

export function SectionHeader({ eyebrow, title, description }) {
  return (
    <div className="mb-10">
      <p className="label-eyebrow text-[#A67C2E] mb-3">{eyebrow}</p>
      <h2 className="font-heading text-3xl md:text-4xl leading-tight mb-3">{title}</h2>
      {description ? (
        <p className="text-[#6B6560] text-sm max-w-lg leading-relaxed">{description}</p>
      ) : null}
    </div>
  );
}
